var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showBackdrop)?_c('div',{staticClass:"bg-opacity",attrs:{"id":"bg-filters"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }